<template>
    <div class="flex h-full items-center">
        <h2 class="font-bold text-xl text-white leading-tight">User Panel</h2>

        <!-- Navigation Links -->
        <div class="hidden h-full sm:ml-10 sm:flex">
            <nav-link
                :href="route('register')"
                :active="route().current('register')"
                v-if="hasPermission('create-user')"
            >
                Add User
            </nav-link>
            <nav-link
                :href="route('manage-user')"
                :active="route().current('manage-user')"
                v-if="hasPermission('manage-user')"
            >
                Manage Users
            </nav-link>
        </div>
    </div>
</template>

<script>
import NavLink from "@/Components/Dashboard/NavLink";

export default {
    components: {
        NavLink,
    },
    computed: {
        user() {
            return this.$page.props.auth.user;
        },
        permissions() {
            let result = [];
            if (this.user && this.user.hasOwnProperty("permissionList")) {
                result = this.user.permissionList;
            }
            return result;
        },
    },
    methods: {
        hasPermission(permission) {
            return this.permissions.includes(permission);
        },
    },
};
</script>
